import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueGeolocation from 'vue-browser-geolocation';
import * as VueGeolocationMap from 'vue2-google-maps';
import i18n from './i18n'



Vue.config.productionTip = false

Vue.use(VueGeolocation);//get user's location
Vue.use(VueGeolocationMap,{
 load:{
   key:''
 }
});//plugin simplify google map implementation
router.beforeEach((to,from,next)=>{
    let user=localStorage.getItem('user');
    if (user) {
      let curentUser=JSON.parse(user);
      let now=new Date().getTime();
      if (curentUser.expire>now) {
        store.state.User=curentUser;
      }else{
        localStorage.removeItem('user');
      }
    }
   if (to.matched.some(record=>record.meta.requiresAuth)) {
     if (store.state.User!=null) {
       next();
     }else{
       next({path: '/login',query:{redirecto:to.name}});
     }
     }else{
     next();
    }
})

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
